jQuery('document').ready(function ($) {
    var filterButton = $('.filter_button');
    var wrapper = $('.module_8');
    var article = $('.module_8_items');
    var currCat;
    var articleCat;
    filterButton.click(function (e) {
        currCat = $(this).data('catfilter');
        filterButton.each(function () {
            $(this).removeClass('active');
        });
        $(this).addClass('active');
        article.each(function (key, value) {
            var _this = this;
            var hasEnterred = false;
            wrapper.css('opacity', 0);
            setTimeout(function () {
                articleCat = $(value).data('categories').split('|');
                if (!hasEnterred) {
                    if (jQuery.inArray(currCat, articleCat) != -1) {
                        $(_this).css('display', 'block');
                        hasEnterred = true;
                    }
                    else {
                        $(_this).css('display', 'none');
                    }
                }
                setTimeout(function () {
                    wrapper.css('opacity', 1);
                }, 100);
            }, 300);
        });
    });
});
